module.exports = __webpack_public_path__ + "0f9358e7cd6cb7086d5ef3500735f01f.pdf";